export const PAPER = 'PAPER'
export const EMAIL = 'EMAIL'
